<template>
  <!-- https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/ -->
  <div class="text-center login-form">
    <form class="form-signin" @submit.prevent="onSubmit">
      <!-- <img class="mb-4" src="../../assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
      <!-- <img class="mb-4" src="../assets/img/logo/logo-dame-una-mano_imageonly_purple.svg" alt="" width="72" height=""> -->
      <h3 class="mb-3 font-weight-normal" style="color: var(--coredarkcolor); margin-bottom: 0;" ref="pageTitle">Login</h3>
      <label for="inputEmail" class="sr-only">Email</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="Email" required autofocus v-model="email">
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="password">
      <!-- <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div> -->
      <button class="btn btn-lg btn-primary btn-block" type="submit">Login</button>
      <p v-if="loginError" class="pt-2"><strong>Sorry, it seems your email or password is incorrect.</strong></p>
      <!-- <p class="mt-5 mb-5 text-muted">&copy; 2017-2018</p> -->
      <!-- <p class="pt-4">¿No tienes un perfil? <router-link to="/iniciar-sesion" class="">Iniciar sesión</router-link></p> -->
      <p class="pt-4 text-muted" style="margin-bottom: 0;">Don't have a nanny profile?</p>
      <p class="" style="margin-bottom: 0;"><router-link :to="{ name: 'Candidate Application Form' }">Join Our Team</router-link></p>
      <p class="pt-3 text-muted" style="margin-bottom: 0;">Not a client yet?</p>
      <!-- <p class="" style="margin-bottom: 0;"><router-link :to="{ name: 'Candidate Registration' }">Join Our Team</router-link></p> -->
      <a href="https://www.goldcoastnannies.com/">Learn About Our Services</a>
      <!-- <p class=""><router-link to="/employer-registration" class="">Employer Registration</router-link></p> -->
      <p class="pt-4 text-muted" style="margin-bottom: 0;">Forgot your password?</p>
      <router-link :to="{ name: 'Password Reset Request' }">Reset Password</router-link>
    </form>
  </div>
</template>

<script>
  // import axios from 'axios';
  import axios from '../axios'; // Don't have to name it axios, can name it anything - Lecture 348

  export default {
    data () {
      return {
        email: '',
        password: '',

        loginError: false,
      }
    },
    created () {
      // this.$store.dispatch('tryAutoLogin')
      // Scroll the window up
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      onSubmit () {
        const formData = {
          email: this.email,
          password: this.password,
        }
        console.log(formData)
        // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
        // axios.post('/users.json', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
        // axios.post('http://127.0.0.1:8000/api-token-auth/', {
        //   username: formData.email,
        //   password: formData.password,
        // })
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))
        this.$store.dispatch('login', {email: this.email, password: this.password})
          .then(() => {
            console.log('Successful login!')
          })
          .catch(error => {
            console.log('problemoo')
            console.log(error)
            // this.loginError = true

            // Some people register with capitalized emails, if we fail to log them in normally, try again with capitalized entries
            this.$store.dispatch('login', {email: this.capitalizeFirstLetter(this.email), password: this.capitalizeFirstLetter(this.password)})
              .then(() => {
                console.log('Successful login with caps!')
              })
              .catch(error => {
                console.log('problemoo even with caps')
                console.log(error)
                this.loginError = true
              })
          })
      }
    }
  }
</script>

<style>
/* Bootstrap sign up form */
/* https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/signin.css */

  .login-form {
    height: 100vh;
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-signin {
    width: 100%;
    max-width: 330px;
    /* min-width: 300px; */
    padding: 15px;
    margin: auto;
  }
  .form-signin .checkbox {
    font-weight: 400;
  }
  .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue